// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rate-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  padding: 24px 18px;
}

.rate-stars {
  display: flex;
  gap: 6px;
}

.rate-star {
  border: 0;
  background: none;
  padding: 2px;
  color: var(--border-strong);
  cursor: pointer;
  transition: transform 0.12s, color 0.15s;
}

.rate-star:hover {
  transform: scale(1.12);
}

.rate-star-on {
  color: #f59e0b;
}

.rate-star-on svg {
  fill: #fbbf24;
}

.rate-label {
  font-family: var(--font-display);
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--muted);
}

.rate-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.rate-file-btn {
  margin-top: 4px;
}

.rate-files {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
}

.rate-files li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 12px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.84rem;
  color: var(--text-soft);
}

.rate-files li span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rate-files button {
  flex-shrink: 0;
  display: inline-flex;
  border: 0;
  background: none;
  color: var(--muted2);
  cursor: pointer;
}

.rate-files button:hover {
  color: var(--danger);
}
`, "",{"version":3,"sources":["webpack://./src/app/client/RateProvider.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".rate-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 9px;\n  padding: 24px 18px;\n}\n\n.rate-stars {\n  display: flex;\n  gap: 6px;\n}\n\n.rate-star {\n  border: 0;\n  background: none;\n  padding: 2px;\n  color: var(--border-strong);\n  cursor: pointer;\n  transition: transform 0.12s, color 0.15s;\n}\n\n.rate-star:hover {\n  transform: scale(1.12);\n}\n\n.rate-star-on {\n  color: #f59e0b;\n}\n\n.rate-star-on svg {\n  fill: #fbbf24;\n}\n\n.rate-label {\n  font-family: var(--font-display);\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n.rate-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.rate-file-btn {\n  margin-top: 4px;\n}\n\n.rate-files {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.rate-files li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 9px 12px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.84rem;\n  color: var(--text-soft);\n}\n\n.rate-files li span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rate-files button {\n  flex-shrink: 0;\n  display: inline-flex;\n  border: 0;\n  background: none;\n  color: var(--muted2);\n  cursor: pointer;\n}\n\n.rate-files button:hover {\n  color: var(--danger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
